import axios from '../api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = async () => {
    try {
      const response = await axios.get('/refresh', { withCredentials: true });

      setAuth((prev) => {
        const { email, password, role } = prev;
        const accessToken = response.data.accessToken as string;
        return { email, password, accessToken, role };
      });
      return response.data.accessToken;
    } catch (error) {}
  };

  return refresh;
};

export default useRefreshToken;
